import React from 'react'
import PropTypes from 'prop-types'

const RightArrowIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="75"
    height="75"
    viewBox="0 0 24 24"
  >
    <title>Next Day</title>
    <path fill={props.disabled ? '#aaaaaa' : '#111111'} d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
    <path fill={'none'} d="M0 0h24v24H0V0z" />
  </svg>
  )

RightArrowIcon.propTypes = {
  disabled: PropTypes.bool.isRequired,
}

export default RightArrowIcon




// WEBPACK FOOTER //
// ./src/components/assets/RightArrowIcon.js